import { PolygonType } from 'models/polygon.model';
import { createContext, ReactNode, useContext } from 'react';
import { CoKitchenType } from 'utils/types';

export type DashboardContextType = {
  activeCokitchen: CoKitchenType;
  setActiveCokitchen: (kitchen: CoKitchenType) => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
  rightSection: ReactNode | null;
  setRightSection: (value: ReactNode | null) => void;
  isRightSectionWide: boolean;
  setIsRightSectionWide: (value: boolean) => void;
  showMobileSidebar: boolean;
  setShowMobileSidebar: (value: boolean) => void;
  cokitchens: CoKitchenType[];
  setCokitchens: (kitchens: CoKitchenType[]) => void;
  polygons: PolygonType[];
  loadPolygons: (ids: string[]) => Promise<void>;
  showStudentAmbassadorModal: boolean;
  setShowStudentAmbassadorModal: (value: boolean) => void;
};

export const DashboardContext = createContext({} as DashboardContextType);

const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  return context;
};

export default useDashboardContext;
